import React, { useEffect, useRef } from "react";
import { Text } from "rebass/styled-components";
import { SiRiotgames } from "react-icons/si";
import styled from "styled-components";
import { useRecoilState } from "recoil";

import { analytics } from "MVVM/Analytics";
import { ModalType } from "../../../@types";
import { useRiotLink } from "../../../Hooks/useRiotLink";
import { useRiotRelinkPrompt } from "../../../Hooks/useRiotRelinkPrompt";
import { AllstarModalState } from "../../../State/modals";
import { Modal } from "../../Modal";
import {
  DialogCard,
  DismissButton,
  IconContainer,
  PrimaryButton,
} from "./styledComponents";

export const RiotRelinkModal = () => {
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const { link } = useRiotLink();
  useRiotRelinkPrompt();
  const dismissTracked = useRef(false);
  const isOpen = allstarModalState.isOpen === ModalType.RiotRelink;

  useEffect(() => {
    if (isOpen) dismissTracked.current = false;
  }, [isOpen]);

  const close = () => {
    setAllstarModalState((prev) => ({ ...prev, isOpen: ModalType.None }));
  };

  const reconnect = () => {
    analytics.track("Riot Relink Prompt Reconnect");
    link("RELINK_PROMPT", { reconnect: true });
    close();
  };

  const dismiss = () => {
    if (dismissTracked.current) return;
    dismissTracked.current = true;
    analytics.track("Riot Relink Prompt Dismissed");
    close();
  };

  return (
    <Modal
      isModalOpen={isOpen}
      setModalOpen={dismiss}
      handleModalClose={dismiss}
      disableOutsideClose={false}
    >
      {/* Modal only draws the scrim; the card is the dialog's own job. */}
      <DialogCard>
        <IconContainer>
          <RiotIcon />
        </IconContainer>
        <Text variant="text.headingMedium" fontWeight={700} textAlign="center">
          Reconnect your Riot account
        </Text>
        <Text variant="text.paragraphMedium" color="chalk" textAlign="center">
          Riot now requires a fresh sign-in before Allstar can fetch your League
          replays. Reconnect to keep clipping League games.
        </Text>
        <PrimaryButton onClick={reconnect}>Reconnect</PrimaryButton>
        <DismissButton onClick={dismiss}>Not now</DismissButton>
      </DialogCard>
    </Modal>
  );
};

const RiotIcon = styled(SiRiotgames)`
  color: ${({ theme }) => theme.colors.ice};
  height: 28px;
  width: 28px;
`;
